import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {TokenUnlockedSuccessService} from "../../lib/services/token-unlocked-success/token-unlocked-success.service";
import {AuthenticationService} from "../../lib/services/autenticacion/authentication.service";

@Component({
  selector: 'lib-token-unlocked-success',
  templateUrl: './token-unlocked-success.component.html',
  styleUrls: ['./token-unlocked-success.component.scss']
})
export class TokenUnlockedSuccessComponent implements OnInit {

  constructor(
    private tokenUnlockedSuccessService: TokenUnlockedSuccessService,
    private authenticationService: AuthenticationService,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }
  closeDialog() {
    this.tokenUnlockedSuccessService.close();
    this.authenticationService.logOut()
    this.router.navigate(['/']);
    // location.reload()
  }
}
